import PieChart from '../components/pie/pie.vue';
import BarChart from '../components/bar/bar.vue';
import MapChart from '../components/map/map.vue';
import LineChart from '../components/line/line.vue';
import mapData from './mapData.js';

const arr1 = [
  
  { value: 62.4, name: "2022年" },
  { value: 52.4, name: "2023年" },
  { value: 74.4, name: "2024年" },
  { value: 52.9, name: "2025年" },
];
const arr2 = [
  
  { value: 95.6, name: "2022年" },
  { value: 97.6, name: "2023年" },
  { value: 125.4, name: "2024年" },
  { value: 50.3, name: "2025年" },
];
const arr3 = [
  
  { value: 358.6, name: "2022年" },
  { value: 334.2, name: "2023年" },
  { value: 384.5, name: "2024年" },
  { value: 379.8, name: "2025年" },
];
const arr4 = [
  
  { value: 625.9, name: "2022年" },
  { value: 607.5, name: "2023年" },
  { value: 658.8, name: "2024年" },
  { value: 677.6, name: "2025年" },
];
const arr5 = [
  
  { value: 625.9, name: "2022年" },
  { value: 607.5, name: "2023年" },
  { value: 658.8, name: "2024年" },
  { value: 677.6, name: "2025年" },
];
const arr6 = [
 
  { value: 301.3, name: "2022年" },
  { value: 252.2, name: "2023年" },
  { value: 393.4, name: "2024年" },
  { value: 134.5, name: "2025年" },
];
const arr7 = [
  
  { value: 301.3, name: "2022年" },
  { value: 252.2, name: "2023年" },
  { value: 393.4, name: "2024年" },
  { value: 134.5, name: "2025年" },
];
const arr8 = [
  
  { value: 185.6, name: "2022年" },
  { value: 194.1, name: "2023年" },
  { value: 308.6, name: "2024年" },
  { value: 100.1, name: "2025年" },
];
export default {
  name: "cdyIndex",

  components: {
    PieChart,
    BarChart,
    MapChart,
    LineChart,
  },

  data() {
    return {
      selleftPanel1: 0,
      progress: true,
      flag1: true,
      flag3: true,
      leftPanel3active1: true,
      leftPanel3active2: true,
      mapData,
      imgarr: [
        {
          url: "https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png",
          show: true,
          name: "园区分布",
        },
        {
          url: "https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png",
          show: true,
          name: "草数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png",
          show: true,
          name: "牛数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png",
          show: true,
          name: "马数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png",
          show: true,
          name: "羊数据",
        },
      ],
      leftPanel1: {
        data: arr1,
        unit: "万吨",
        color: ["#33a7ff", "#5c17e5", "#b800ff", "#ff66e5"],
        title: "产量",
      },
      leftPanel1s: {
        data: arr2,
        unit: "万亩",
        color: ["#33a7ff", "#5c17e5", "#b800ff", "#ff66e5"],
        title: "面积",
      },
      leftPanel2: {
        series: [
          {
            name: "全国",
            value: [63974250, 65103900, 65962200, 68008050, 68481750, 68485750, 68489750, 78489750,80589751],
            colors: 0,
            show: true,
          },
          {
            name: "内蒙",
            value: [
              5096250, 5447850, 5626500, 5000034.6, 5201360.55, 5203360.55, 5211360.55, 5711360.55,5322361.55
            ],
            colors: 1,
            show: true,
          },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      leftPanel2active1: true,
      leftPanel2active2: true,
      flag2: true,
      leftPanels: {
        series: [
          {
            name: "全国",
            value: [
              5096250, 5447850, 5626500, 5000034.6, 5201360.55, 5666500, 5070034.6, 5211360.55,5311360.55,
            ],
            colors: 0,
            show: true,
          },
          {
            name: "内蒙",
            value: [63974250, 65103900, 65962200, 68008500, 68481750, 65952200, 68028500, 68491750, 70491750],
            colors: 1,
            show: true,
          },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      leftPanel3: {
        series: [
          {
            name: "全国",
            unit: "万亩",
            value: [
              19510.97, 19812.61, 20867.09, 23083.6, 20561.99, 19659.34, 19035.97, 18492.65,
              18667.32, 18978.54, 21978.54, 25978.54,26278.54,
            ],
            show: true,
            colors: 0,
            stack: "item",
          },
          {
            name: "内蒙",
            unit: "万亩",
            value: [
              4311.8, 4409, 4499.4, 4892.2, 4385.23, 3987.56, 3683.5, 5216.87, 5327.43, 5476.59,
              5376.59, 6476.59,6276.59,
            ],
            show: true,
            colors: 1,
            stack: "item",
          },
        ],
        category: [
          "2013年",
          "2014年",
          "2015年",
          "2016年",
          "2017年",
          "2018年",
          "2019年",
          "2020年",
          "2021年",
          "2022年",
          "2023年",
          "2024年",
          "2025年",
        ],
      },
      leftPanel4: {
        series: [
          {
            name: "牛",
            value: [150, 230, 224, 218, 135, 147],
          },
          {
            name: "羊",
            value: [120, 250, 204, 118, 115, 137],
          },
        ],
        category: ["2015", "2016", "2017", "2018", "2019", "2020"],
      },
      rightPanel1: {
        series: [
          {
            name: "全国",
            value: [102805.65, 103864.86, 106500, 109942.02, 100942.02, 111300, 116300, 111200, 121200],
            show: true,
            colors: 0,
            unit: "万亩",
          },
          {
            name: "内蒙",
            value: [10015.65, 10364.86, 10600, 10942.02, 1430, 11300, 5100, 11100, 8100],
            show: true,
            colors: 1,
            unit: "万亩",
          },
          // {
          //   name: '苜蓿草',
          //   value: [2700, 2500, 2750, 2810, 2790, 2540, 2400],
          //   show: true,
          //   colors: 2,
          //   unit: '万亩',
          // },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      rightPanel2: {
        series: [
          {
            name: "燕麦草",
            value: [1882, 1450, 1630, 1400, 199, 2185, 2200, 2288, 2355],
            show: true,
            colors: 0,
          },
          {
            name: "青干草",
            value: [1000, 1200, 1000, 1030, 1450, 1290, 1715, 1500, 1825],
            show: true,
            colors: 1,
          },
          {
            name: "苜蓿草",
            value: [600, 180, 800, 900, 580, 780, 850, 1370, 2370],
            show: true,
            colors: 2,
          },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      rightPanel3: {
        series: [
          {
            name: "平台覆盖牛源量趋势",
            value: [150, 230, 224, 218, 135, 147, 150, 230, 224, 218, 135, 147],
          },
        ],
        category: [
          ["01", "2021"],
          ["02", "2021"],
          ["03", "2021"],
          ["04", "2021"],
          ["05", "2021"],
          ["06", "2021"],
          ["07", "2021"],
          ["08", "2021"],
          ["09", "2021"],
          ["10", "2021"],
          ["11", "2021"],
          ["12", "2011"],
        ],
      },
      rightPanel4: [0, 0],
    };
  },

  mounted() {
    this.rightPanel4 = [61, 19];

    setInterval(() => {
      this.progress = false;
      this.rightPanel4 = [0, 0];
      setTimeout(() => {
        this.progress = true;
        this.rightPanel4 = [61, 19];
      }, 300);
    }, 8000);
  },
  methods: {
    imgarrCLick(item) {
      item.show = !item.show;
    },
    leftPanel1Click(index) {
      this.selleftPanel1 = index;
      this.flag1 = !this.flag1;
      let ars = [];
      let ars2 = [];
      if (index == 0) {
        ars = arr1;
        ars2 = arr2;
      } else if (index == 1) {
        ars = arr3;
        ars2 = arr4;
      } else if (index == 2) {
        ars = arr5;
        ars2 = arr6;
      } else if (index == 3) {
        ars = arr7;
        ars2 = arr8;
      }
      this.leftPanel1.data = ars;
      this.leftPanel1s.data = ars2;
    },
    leftPanel2Click1() {
      this.leftPanel2active1 = !this.leftPanel2active1;
      this.leftPanel2.series[0].show = !this.leftPanel2.series[0].show;
      this.flag2 = !this.flag2;
    },
    leftPanel2Click2() {
      this.leftPanel2active2 = !this.leftPanel2active2;
      this.leftPanel2.series[1].show = !this.leftPanel2.series[1].show;
      this.flag2 = !this.flag2;
    },
    leftPanel3Click1() {
      this.leftPanel3active1 = !this.leftPanel3active1;
      this.leftPanel3.series[0].show = !this.leftPanel3.series[0].show;
      this.flag3 = !this.flag3;
    },
    leftPanel3Click2() {
      this.leftPanel3active2 = !this.leftPanel3active2;
      this.leftPanel3.series[1].show = !this.leftPanel3.series[1].show;
      this.flag3 = !this.flag3;
    },
  },
};
